import { useState } from "react";
import { Button, useNotify } from "react-admin";
import { Grid, TextField, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";
import { NationalityType } from "utils/choices";
import { useNotifyError } from "utils/useNotifyError";

const ElectiveGroupRow = ({ group, curriculumId, academicYearId, onSaved }) => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const [draft, setDraft] = useState(group.amount ?? "");
  const [saving, setSaving] = useState(false);

  const saved = group.amount ?? "";
  const dirty = (draft === "" ? "" : Number(draft)) !== (saved === "" ? "" : Number(saved));

  const handleSave = async () => {
    const amount = draft === "" ? null : Number(draft);

    if (amount < 0) {
      notify("Цената не може да е отрицателна!", { type: "error" });
      return;
    }

    setSaving(true);
    try {
      await dataProvider.customRequest(
        studentRequests.saveElectiveGroupPrice(curriculumId, academicYearId, group.groupId),
        { amount },
        "PUT",
      );
      notify("Успешно записана цена", { type: "success" });
      onSaved();
    } catch (err) {
      notifyError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Grid
      container
      spacing={1}
      alignItems="center"
      sx={{ mb: 1 }}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <Typography sx={{ wordBreak: "break-word" }}>{group.nameBg}</Typography>
      </Grid>
      <Grid
        item
        xs={6}
        md={2}
      >
        <Typography align="center">
          {NationalityType.find(option => option.id === group.nationality)?.name ?? "-"}
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        md={2}
      >
        <TextField
          value={draft}
          onChange={e => setDraft(e.target.value)}
          label="Цена (EUR)"
          type="number"
          size="small"
          InputProps={{ inputProps: { min: 0, step: 0.01 } }}
          onWheel={e => e.target.blur()}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
        sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 0.5 }}
      >
        <Button
          label="Запази"
          startIcon={<SaveIcon />}
          onClick={handleSave}
          disabled={!dirty || saving}
        />
        <Button
          label="Откажи"
          startIcon={<CloseIcon />}
          onClick={() => setDraft(saved)}
          disabled={!dirty || saving}
        />
      </Grid>
    </Grid>
  );
};

export default ElectiveGroupRow;
